import {useIsFeatureActive} from '@aboutyou/feature-flags';

export const useIsCrmCouponsEnabled = () => {
  return useIsFeatureActive('crm_coupons').isActive;
};
